/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { BrandColors } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  cardWrapper: {
    backgroundColor: BrandColors.WHITE,
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: `24px 40px`,
    width: 480,
  },
});

export namespace FormCardWrapper {
  export interface Props {}
}

export const FormCardWrapper: React.FC<FormCardWrapper.Props> = ({ children }) => (
  <div className={css(styles.cardWrapper)}>{children}</div>
);
